import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import "../InsuranceDashboard.css";
import { MODULE_API } from "../../../apis";
import moment from "moment";
import { chartColors } from "../../../components/form/debtPayOff/components/color";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
export const InsuranceInfo = ({ fetchChartData }) => {
  const [chartData, setChartData] = useState();
  const [loading, setLoading] = useState(false);

  // Step 1: Extract all unique policies
  const allPolicies = chartData && new Set();
  chartData &&
    Object.values(chartData).forEach((entries) => {
      entries &&
        entries.forEach((entry) => {
          Object.keys(entry).forEach(
            (key) => allPolicies && allPolicies.add(key)
          );
        });
    });

  // Step 2: Sort the labels in correct order and extract them
  const sortedMonths =
    chartData &&
    Object.keys(chartData).sort(
      (a, b) =>
        moment(a, "MMMM YYYY").toDate() - moment(b, "MMMM YYYY").toDate()
    );

  // Convert labels to abbreviated form (Jan, Feb, etc.)
  const chartLabels =
    sortedMonths &&
    sortedMonths.map((label) => moment(label, "MMMM YYYY").format("MMM"));

  // Step 3: Build datasets for each policy
  const datasets =
    allPolicies &&
    Array.from(allPolicies).map((policyName, index) => {
      const backgroundColors = chartColors; // expand if more policies
      return {
        type: "bar",
        label: policyName,
        stack: "stack1",
        backgroundColor: backgroundColors[index % backgroundColors.length],
        data:
          sortedMonths &&
          sortedMonths.map((month) => {
            const entries = chartData[month];
            const entry = entries && entries.find((e) => policyName in e);
            return entry ? parseFloat(entry[policyName]).toFixed(2) : 0;
          }),
      };
    });

  // Step 4: Final chart data object
  const data = {
    labels: chartLabels || [],
    datasets: datasets || [],
  };
  const getInsuarnceChart = async () => {
    try {
      setLoading(true);
      const datares = await MODULE_API.fetchInsuranceChart();
      console.log("dangerMode", datares);
      if (datares && datares.data && datares.data) {
        const formatted = Object.entries(datares.data).reduce(
          (acc, [month, arr]) => {
            acc[month] = arr.map((obj) => {
              const newObj = {};
              Object.entries(obj).forEach(([key, value]) => {
                if (typeof value === "number") {
                  newObj[key] = parseFloat(value.toFixed(2)); // ✅ 2 decimals
                } else if (value === null) {
                  newObj[key] = 0.0; // ✅ null → 0
                } else {
                  newObj[key] = value;
                }
              });
              return newObj;
            });
            return acc;
          },
          {}
        );
        setChartData(datares.data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getInsuarnceChart();
  }, [fetchChartData]);
  return (
    <React.Fragment>
      <div className="incomeInfoMaincard">
        <h3
          className="incomecardheading"
          style={{ textAlign: "center", fontSize: "16px" }}
        >
          Monthly Premiums
        </h3>
        <div style={{ marginTop: "1rem" }}>
          <Line
            data={data}
            height={80}
            options={{
              legend: {
                display: true,
              },
              tooltips: {
                callbacks: {
                  label: function (tooltipItem, chartData) {
                    // Get dataset label
                    const datasetLabel =
                      chartData.datasets[tooltipItem.datasetIndex].label || "";
                    // Get value
                    const value = tooltipItem.yLabel;
                    // Format to 2 decimals
                    const formattedValue = parseFloat(value)
                      .toFixed(2)
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    return `${datasetLabel}: $${formattedValue}`;
                  },
                },
              },
              scales: {
                xAxes: [
                  {
                    stacked: true,
                    gridLines: {
                      color: "rgba(0, 0, 0, 0)",
                    },
                  },
                ],
                yAxes: [
                  {
                    stacked: true,
                    ticks: {
                      beginAtZero: true,
                      callback: function (value) {
                        return new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(value);
                      },
                    },
                    gridLines: {
                      color: "rgba(0, 0, 0, 0)",
                    },
                  },
                ],
              },
              plugins: {},
            }}
          />
        </div>
        <NewLoader isLoading={loading} />
      </div>
    </React.Fragment>
  );
};
